import Application from 'app/enums/Application'

export default function(input){

    switch(input){

        case Application.MIJN_AVECO: return 'Mijn Aveco de Bondt';
        case Application.MONITOR: return 'Aveco Monitor';
        case Application.VELDWERKWINKEL: return 'Aveco Veldwerkwinkel';
        case Application.LOGGERS: return 'Aveco Loggerdatabase';
        case Application.VELDWERKDATA: return 'Aveco Veldwerkdata';

        default: return '';
    }
}
